import { SelectedAnzeige } from './../selected-anzeige';
import { Component, OnInit } from '@angular/core';
import { RestApiService } from "../shared/rest-api.service";
import { on_off_animation } from '../animations/animations';

@Component({
  selector: 'app-anzeigen-list',
  templateUrl: './anzeigen-list.component.html',
  styleUrls: ['./anzeigen-list.component.scss'],
  animations: [on_off_animation]
})
export class AnzeigenListComponent implements OnInit {

  Anzeige: any = [];
  collectionSize : number = 0;
  pageSize : number = 20;
  page : number = 0;
  selA: SelectedAnzeige;

  constructor(public restApi: RestApiService, public selAA: SelectedAnzeige ) {
    this.selA = selAA;
  }

  ngOnInit(): void {
    this.loadAnzeigen()
  }


  // Get Liste
  loadAnzeigen() {
    return this.restApi.getAnzeigen().subscribe((data: {}) => {
      this.Anzeige = data;
      this.collectionSize = this.Anzeige.length/2;
    //   console.log("------ANZEIGE---------->"+JSON.stringify(this.Anzeige));
    })
  }

  sendData(name: string, vorname:string, a_trauerkartePfad: string, trauerkarte_url:string){
    // console.log("#######################-> "+name+"-----"+vorname+"-----------"+trauerkarte_url+"-----------"+a_trauerkartePfad);
    this.selA.setSelected(name, vorname, a_trauerkartePfad, trauerkarte_url);
  }


  isImageLoad(e: Event){
    let image = <HTMLImageElement> e.target;
    image.classList.add("loaded");
  }

}
